import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acumatica } from '../acumatica-field-decorator';

@Injectable({
    providedIn: 'root'
})
export class ItemSpecsService extends AcumaticaEntityService {
    constructor(acumatica: AcumaticaService) {
        super(acumatica, 'ItemSpecifications', ItemSpecifications);
    }

    get(ItemClassID: string, options: AcumaticaRequestOptions = {}): Observable<ItemSpecifications> {
        return super.getEntity(ItemClassID, {
            ...{ message: "Getting Item Specifications" },
            ...options
        });
    }
}

export class ItemSpecifications extends AcumaticaEntity {
    @Acumatica() ItemClassID!: string;
    @Acumatica({ write: false }) AbrasionResistance?: string;
    @Acumatica({ write: false }) Backing?: string;
    @Acumatica({ write: false }) Finish?: string;
    @Acumatica({ write: false }) RollLength?: string;
    @Acumatica({ write: false }) Weight?: string;
    @Acumatica({ write: false }) Width?: string;
    @Acumatica({ write: false }) PricelistCategory?: string;
    @Acumatica({ write: false }) PricelistType?: string;
    @Acumatica({ write: false }) WebComment?: string;
    @Acumatica({ write: false }) CleaningComments?: string;
    @Acumatica({ write: false }) ContentDescription?: string;
}